import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import Modal from 'react-responsive-modal';
import ReactModal from 'react-modal';
import '../assets/styles/settings.css';
import '../assets/styles/docs.scss';
import '../assets/styles/dashboard.scss';
import ViewProfile from '_components/Profile/ViewProfile';
import { BulletinBoard } from './BulletinBoard';
import { EditProfile } from './EditProfile';
import { Permissions } from './Permissions';
import { DocsList } from './DocsList';
import { notificationActions, permissionActions, chatActions, inventoryActions } from '../_actions';
import InventoryAlertModal from '../common/InventoryAlertModal';
import { userActions } from '../_actions';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import PropTypes from 'prop-types';
import ChangePassword from 'ChangePassword';
import UserQualifications from 'UserQualifications';
import ErrorBoundary from '_components/ErrorBoundary';
import UpdateEmployeeTraining from 'EmployeeTraining';
import Management from './Management';
import SystemManage from './SystemManage';
import ApplicantsTab from 'ApplicantTab';
import { profileService } from '_services/profile.service';
import { docsService } from '_services/docs.service';
import { toast } from 'react-toastify';
import { handleErrorResponse } from '_helpers/helpers';
import { formatDate } from '_helpers/helpers';
import { authHeader, config } from '../_helpers';
import SmsNotification from 'SmsNotification/SmsNotification';
import { profileType } from '_constants';
import { ApplicationHistory } from 'Applicants/ApplicationHistory';
import { AlertPopup } from '../_components/AlertPopup';
import { DocumentButtons } from '../common/Profile';

class SettingsProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mainHtml: '',
      step: this.props.match.params.step,
      statusOpen: false,
      status: '',
      available: '',
      statusStep: '1',
      returnDateField: moment(),
      returnDate: '',
      permission: [],
      h1: '',
      unavailableErr: '',
      unavailableDescriptionErr: '',
      unavailableReason: 0,
      otherReason: '',
      sendingDDForm: false,
      send_dd_form_confirm: false,
      reloadKey: 0,
      loader: false,
      mailSendOpen: false,
      removeOpen: false,
      inventoryUserAlert: false,
      message: '',
      alertPop: false,
      alertOpen: false,
      head: '',
      alertMsg: '',
      alertFunction: '',
      email: '',
      request_rehire_doc: false,
      doc_request: '',
      request_rehire_doc_status: false,
      // Lock profile states
      is_locked: 0,
      lastDayWorked: moment(),
      lastDayReason: '',
      lastDayReasonErr: '',
      requireDocs: false,
      inventoryAlertAction: 'remove',
      archiveStep: '3a',
      redirect: null,
    };
    this.changeTab = this.changeTab.bind(this);
    this.statusOpenModal = this.statusOpenModal.bind(this);
    this.statusCloseModal = this.statusCloseModal.bind(this);
    this.setStatusReturn = this.setStatusReturn.bind(this);
    this.setStep = this.setStep.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.cancel = this.cancel.bind(this);
    this.editProfile = this.editProfile.bind(this);
    this.viewHistory = this.viewHistory.bind(this);
    this.viewDetails = this.viewDetails.bind(this);
    this.mailSendOpenModal = this.mailSendOpenModal.bind(this);
    this.mailSendCloseModal = this.mailSendCloseModal.bind(this);
    this.handleRemoveEmployee = this.handleRemoveEmployee.bind(this);
    this.handleLockProfile = this.handleLockProfile.bind(this);
    this.lockProfile = this.lockProfile.bind(this);
    this.unlockProfile = this.unlockProfile.bind(this);
    this.remove = this.remove.bind(this);
    this.removeCloseModal = this.removeCloseModal.bind(this);
    this.alertOpenModal = this.alertOpenModal.bind(this);
    this.alertCloseModal = this.alertCloseModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.sendMailToApplicant = this.sendMailToApplicant.bind(this);
    this.documentRequest = this.documentRequest.bind(this);
    this.downloadAllDocuments = this.downloadAllDocuments.bind(this);
    this.downloadAllDocumentsAsPDF = this.downloadAllDocumentsAsPDF.bind(this);
    this.docRequestModalClose = this.docRequestModalClose.bind(this);
    this.collectLastDayWorked = this.collectLastDayWorked.bind(this);
  }

  viewHistory(hash, applnType = '') {
    this.setState(
      { step: 'ApplicationHistory', hash: hash, applnType },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  viewDetails(hash, applnType = '') {
    this.setState(
      { step: 'ViewApplicant', hash: hash, applnType },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  openDdformConfirmModal() {
    this.setState({ send_dd_form_confirm: true });
  }

  ddFormConfirmCloseModal() {
    this.setState({
      send_dd_form_confirm: false,
    });
  }

  mailSendOpenModal() {
    this.setState({ mailSendOpen: true });
  }

  mailSendCloseModal() {
    this.setState({ mailSendOpen: false });
  }

  handleRemoveEmployee(e) {
    let inventoryList = this.props.inventory?.inventory?.data || [];
    if (inventoryList?.length) {
      this.setState({ inventoryUserAlert: true, inventoryAlertAction: 'remove', statusOpen: false });
    } else {
      this.setState({ removeOpen: true });
    }
  }

  handleLockProfile(e) {
    let inventoryList = this.props.inventory?.inventory?.data || [];
    if (inventoryList?.length) {
      this.setState({ inventoryUserAlert: true, inventoryAlertAction: 'lock', statusOpen: false });
    } else {
      this.setStep('1b');
    }
  }

  removeCloseModal() {
    this.setState({ removeOpen: false, archiveStep: '3a' });
  }

  collectLastDayWorked() {
    this.setState({ archiveStep: '3b' });
  }

  alertOpenModal() {
    this.setState({ alertOpen: true });
  }

  alertCloseModal() {
    this.setState({ alertOpen: false, redirect: '/dashboard' }, () => {
      this?.props.dispatch({
        type: 'REMOVEPROFILE_SUCCESS',
        removeUser: null,
      });
    });
  }

  sendMail(hash) {
    let data = new FormData();
    this.mailSendCloseModal();
    data.append('type', 'mail');
    data.append('message', this.state.message);
    data.append('user_hash', hash);
    const self = this;
    fetch(config.apiUrl + '/api/employee/sendmails', {
      headers: authHeader(),
      method: 'POST',
      body: data,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.success) {
          self.setState({
            alertPop: true,
            alertHead: 'Success',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        } else {
          self.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        }
      });
  }

  sendMailToApplicant(hash, email) {
    let data = new FormData();
    data.append('type', 'mail');
    data.append('message', this.state.message);
    data.append('user_hash', hash);
    data.append('email', email);
    const self = this;
    fetch(config.apiUrl + '/api/employee/sendmails', {
      headers: authHeader(),
      method: 'POST',
      body: data,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.success) {
          self.setState({
            alertPop: true,
            alertHead: 'Success',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        } else {
          self.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        }
      });
  }

  documentRequest(hash, doc_request) {
    this.setState({ doc_request });
    docsService.requestToFillDocs(hash, doc_request).then(
      (res) => {
        this.setState({
          request_rehire_doc_status: res.success,
          request_rehire_doc: true,
        });
        const profileHash = '?hash=' + (this.props.user?.items?.data?.hash || this.props.user?.profile?.data?.hash);
        this.props.dispatch(userActions.getProfile(profileHash));
      },
      (err) => console.log(err),
    );
  }

  docRequestModalClose() {
    this.setState({ request_rehire_doc: false });
  }

  downloadAllDocuments(event, rehire = false, giss = false) {
    let hash = this.props.user?.items?.data?.hash || this.props.user?.profile?.data?.hash;
    let params = {
      uid: this.props.user?.profile?.data?.hash,
      signature: this.props.chat?.settings?.signature,
    };
    let url = new URL(`${config.apiUrl}/docs/download/${hash}`);
    rehire &&
      (url = new URL(`${config.apiUrl}/docs/download/${hash}?rehire=true`));
    giss && (url = new URL(`${config.apiUrl}/docs/download/${hash}?giss=true`));
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key]),
    );
    window.open(url.href);
  }

  downloadAllDocumentsAsPDF(event, rehire = false, giss = false) {
    let hash = this.props.user?.items?.data?.hash || this.props.user?.profile?.data?.hash;
    let params = {
      uid: this.props.user?.profile?.data?.hash,
      signature: this.props.chat?.settings?.signature,
    };
    let url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}`);
    rehire &&
      (url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}?rehire=true`));
    giss &&
      (url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}?giss=true`));

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key]),
    );
    window.open(url.href);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  closeAlert() {
    this.setState({
      alertPop: false,
    });
  }

  remove() {
    if (!this.state || !this.state.lastDayReason || !this.state.lastDayReason.trim()) {
      this.setState({
        lastDayReasonErr: 'error',
      });
      return;
    }
    let data = new FormData();
    this.removeCloseModal();
    data.append(
      'hash',
      this.props.user?.items?.data?.hash ||
        this.props.user?.profile?.data?.hash,
    );
    data.append(
      'last_day_worked',
      moment(this.state.lastDayWorked).format('YYYY-MM-DD'),
    );
    data.append('last_day_reason', this.state.lastDayReason);
    this.props.dispatch(userActions.removeEmployee(data));
  }

  sendDDForm() {
    if (this.props.user.items.data.hash) {
      this.setState({
        ...this.state,
        sendingDDForm: true,
        send_dd_form_confirm: false,
      });
      let data = new FormData();
      data.append('user_hash', this.props.user.items.data.hash);
      profileService
        .sendDDForm(data)
        .then((res) => {
          if (res.success) {
            toast.success(res.message);
          } else {
            handleErrorResponse(res);
          }
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        })
        .catch((error) => {
          toast.error('Failed to send email to user.');
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        });
    } else {
      toast.error('An unexpected error occurred.');
    }
  }

  statusOpenModal() {
    this.setState({ statusOpen: true, statusStep: '1' });
  }

  statusCloseModal() {
    this.setState({
      statusOpen: false,
      unavailableReason: 0,
      unavailableErr: '',
      unavailableDescriptionErr: '',
      otherReason: '',
    });
  }

  changeStepParam = (newStep) => {
    const { history, match } = this.props;
    const { hash } = match.params;

    history.replace(`/profile/${hash}/${newStep}`);
  };

  changeTab(tab) {
    this.changeStepParam(tab);
    this.setState({ step: tab }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  //Change the reason for unavailability
  changeUnavailabilityReason = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      unavailableDescriptionErr: '',
      unavailableErr: '',
    });
    e.target.setAttribute('errors', '');
  };

  setStatusReturn(status) {
    if (Number(this.state.unavailableReason) === Number(0)) {
      this.setState({
        unavailableErr: 'error',
      });
      return;
    }
    if (!this.state.otherReason.trim()) {
      this.setState({
        unavailableDescriptionErr: 'error',
      });
      return;
    }
    if (status) {
      var step = '2a';
    } else {
      step = '2b';
      this.setState({
        returnDate: '',
      });
    }

    this.setState({ statusStep: step }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }
  setStep(step) {
    this.setState({ statusStep: step }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  handleDateChange(date) {
    this.setState({
      returnDateField: date,
      returnDate: date.format('MM/DD/YY'),
    });
  }

  changeStatus(status, statVal) {
    if (status) {
      var stat = statVal === 'Available' ? 'Unavailable' : 'Available';
      this.setState({ status: stat, loader: true }, function () {
        this.componentWillReceiveProps(this.props);
      });

      let data = new FormData();

      data.append('hash', this.props.match.params.hash);
      data.append('end_date', this.state.returnDate);
      data.append('status', stat);
      data.append(
        'unavailableReason',
        this.state.unavailableReason ? this.state.unavailableReason : 0,
      );
      // if (this.state.unavailableReason === "4") {
      data.append(
        'otherReason',
        this.state.otherReason ? this.state.otherReason : '',
      );
      var hash = '?hash=' + this.props.match.params.hash;
      if (this.props.match.params.hash === localStorage.getItem('hash')) {
        this.props.dispatch(userActions.changeSelfStatus(data));
      } else {
        this.props.dispatch(userActions.changeStatus(data, hash));
      }
      this.props.dispatch(notificationActions.getCount());
    }
  }

  lockProfile() {
    if (!this.state || !this.state.lastDayReason || !this.state.lastDayReason.trim()) {
      this.setState({
        lastDayReasonErr: 'error',
      });
      return;
    }
    var stat = 'Locked';
    var hash = '?hash=' + this.props.match.params.hash;
    let data = new FormData();

    data.append('hash', this.props.match.params.hash);
    data.append('status', stat);
    data.append(
      'last_day_worked',
      moment(this.state.lastDayWorked).format('YYYY-MM-DD'),
    );
    data.append('modify_active_status', true);
    data.append('last_day_reason', this.state.lastDayReason);
    this.props.dispatch(userActions.lockUserToggle(data, hash));
    this.props.dispatch(notificationActions.getCount());
    this.setState({ status: stat, loader: true });
  }

  unlockProfile() {
    if (!this.state) {
      console.error('Component state is not initialized');
      return;
    }
    var stat = 'Unlocked';
    var hash = '?hash=' + this.props.match.params.hash;
    let data = new FormData();
    data.append('hash', this.props.match.params.hash);
    data.append('status', stat);
    data.append('document', this.state.requireDocs);
    data.append('modify_active_status', true);
    this.props.dispatch(userActions.lockUserToggle(data, hash));
    this.props.dispatch(notificationActions.getCount());
    this.setState({ status: stat, loader: true });
  }

  requireDocs(e) {
    this.setState({ requireDocs: e.target.checked });
  }

  changeLastDayReason = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      lastDayReasonErr: '',
    });
  };

  handleLastDayChange(date) {
    if (date) {
      this.setState({
        lastDayWorked: date,
      });
    }
  }

  editProfile() {
    this.setState({ step: 'EditProfile' }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }
  cancel() {
    this.setState({ step: 'Profile' }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  componentDidMount() {
    var hash = '?hash=' + this.props.match.params.hash;
    this.props.dispatch(userActions.getProfile(hash));
    this.componentWillReceiveProps(this.props);
    this.props.dispatch(permissionActions.getPermission());
    this.props.dispatch(chatActions.getConversationSettings());
    
    // Load inventory data for inventory check
    let data = new FormData();
    data.append('hash', this.props.match.params.hash);
    this.props.dispatch(inventoryActions.getInventoryList(data));
    
    if (
      this.props.match.path === '/profile/:hash/docs-list/:category/:doc/:id'
    ) {
      this.changeTab('docs-list');
    }
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props;
    
    if (user?.lockProfileSuccess && !prevProps.user?.lockProfileSuccess) {
      this.statusCloseModal();
      toast.success('Profile updated successfully');
      this.setState({
        reloadKey: this.state.reloadKey + 1,
        lastDayReason: '',
        lastDayWorked: moment(),
        loader: false,
      });
    }

    if (user?.lockProfileFailure && !prevProps.user?.lockProfileFailure) {
      this.statusCloseModal();
      toast.error('Failed to update profile');
      this.setState({ loader: false });
    }

    if (user?.changeStatusSuccess && !prevProps.user?.changeStatusSuccess) {
      this.statusCloseModal();
      this.setState({ reloadKey: this.state.reloadKey + 1, loader: false });
    }

    if (user?.changeStatusFailure && !prevProps.user?.changeStatusFailure) {
      this.statusCloseModal();
      this.setState({ loader: false });
    }

    // Handle remove user success/failure
    if (user?.removeUser && !prevProps.user?.removeUser) {
      if (user.removeUser.success) {
        this.setState({
          head: 'Success',
          alertMsg: user.removeUser.message,
          removeOpen: false,
          alertOpen: true,
        });
      } else {
        this.setState({
          alertPop: true,
          alertHead: 'Error',
          alertMsg: user.removeUser.message,
          alertFunction: '',
          removeOpen: false,
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { permission } = this.props;
    if (permission.permissions) {
      // permList = permission.permissions.data
      this.setState({ permission: permission.permissions.data });
    }

    if (nextProps.user.items) {
      var admin = nextProps.user.items.data.is_admin !== 0 ? true : false;
      if (
        this.props.match.path === '/profile/:hash/:step' ||
        this.props.match.path === '/profile/:hash/docs-list/:category/:doc/:id'
      ) {
        this.setState({
          h1:
            nextProps.user.items.data.first_name +
            ' ' +
            nextProps.user.items.data.last_name,
          admin,
          namePrefix: nextProps.user.items.data.first_name,
        });
      } else {
        this.setState({ h1: 'Profile & Settings', admin, namePrefix: 'you' });
      }
      var available =
        nextProps.user.items.data.active === 'Available' ? true : false;
      this.setState({
        status: nextProps.user.items.data.active,
        available: available,
        is_locked: nextProps.user.items.data.is_locked,
      });
    }
    var options;
    if (this.state.step === 'profile') {
      options = (
        <div>
          <ViewProfile
            userHash={this.props.match.params.hash}
            authUser={this.props.user?.profile?.data}
            permList={this.state.permission}
            changeTab={this.changeTab}
            reloadKey={this.state.reloadKey}
          />
        </div>
      );
    }
    if (this.state.step === 'docs-list') {
      options = (
        <div>
          <DocsList userHash={this.props.match.params.hash} />
        </div>
      );
    }
    if (this.state.step === 'qualifications') {
      options = (
        <ErrorBoundary>
          <UserQualifications />
        </ErrorBoundary>
      );
    }
    if (this.state.step === 'trainings') {
      options = (
        <ErrorBoundary>
          <UpdateEmployeeTraining userHash={this.props.match.params.hash} />
        </ErrorBoundary>
      );
    }
    if (this.state.step === 'bulletin') {
      options = (
        <div>
          <BulletinBoard />
        </div>
      );
    }
    if (this.state.step === 'permissions') {
      options = (
        <div>
          <Permissions />
        </div>
      );
    }
    if (this.state.step === 'EditProfile') {
      options = (
        <div>
          <EditProfile {...nextProps} cancel={this.cancel.bind(this)} />
        </div>
      );
    }
    if (this.state.step === 'management') {
      options = (
        <div>
          <Management
            {...nextProps}
            changeTab={this.changeTab}
            cancel={this.cancel.bind(this)}
          />
        </div>
      );
    }

    if (this.state.step === 'system-management') {
      options = (
        <div>
          <SystemManage
            {...nextProps}
            changeTab={this.changeTab}
            cancel={this.cancel.bind(this)}
          />
        </div>
      );
    }
    if (this.state.step === 'application') {
      options = (
        <div>
          {this.props?.user?.items?.data?.applicant_hash && (
            <ApplicantsTab
              hash={this.props?.user?.items?.data?.applicant_hash}
              isApplicationEditable={false}
              applnType={this.state.applnType}
              goBack=''
              email={this.state.email}
              sendMail={this.sendMailToApplicant}
              editApplicant=''
              viewHistory={this.viewHistory}
            />
          )}
        </div>
      );
    }

    if (this.state.step === 'ViewApplicant') {
      options = (
        <div>
          <ApplicantsTab
            hash={this.state.hash}
            isApplicationEditable={false}
            applnType={this.state.applnType}
            goBack={() => this.changeTab('application')}
            email={this.state.email}
            sendMail={this.sendMailToApplicant}
            editApplicant=''
            viewHistory={this.viewHistory}
          />
        </div>
      );
    }

    if (this.state.step === 'ApplicationHistory') {
      options = (
        <div>
          <ApplicationHistory
            hash={this.state.hash}
            applnType={this.state.applnType}
            goBack={() => this.props.goBack()}
            viewDetails={this.viewDetails}
          />
        </div>
      );
    }

    this.setState({ mainHtml: options });
  }
  //
  render() {
    const { permission, user } = this.props;
    var permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
    }

    if (this.state.redirect === '/dashboard') {
      return <Redirect to={'/dashboard'} />;
    }

    var admin = false,
      editPerm = true,
      userItem;
    if (
      this.props.user.profile &&
      (!this.props.match.path === '/profile/:hash' ||
        this.props.match.path === '/profile/:hash/docs-list/:category/:doc/:id')
    ) {
      userItem = this.props.user.profile;
    } else if (this.props.user.items) {
      userItem = this.props.user.items;
    }
    let userData = user.profile ? user.profile.data : {};
    var namePrefix = '';
    if (userItem) {
      var status = userItem.data.active;
      var available = userItem.data.active === 'Available' ? true : false;
      admin = userItem.data.is_admin !== 0 ? true : false;
      var h1 = 'Settings';
      namePrefix = 'you';
      if (userData?.id != userItem?.data?.id) {
        h1 = userItem.data.first_name + ' ' + userItem.data.last_name;
        editPerm = permList.includes('Status Update') ? true : false;
        namePrefix = this.state.namePrefix;
      }
    }

    // if(userItem){
    return (
      <div>
        <div>
          <div className='settings_container'>
            <div className='page_title float'>
              <h1 className=''>{this.state.h1}</h1>

              <div className='btn_list'>
                {this.state.step === 'docs-list' ? (
                  <DocumentButtons
                    user={userItem?.data}
                    permList={permList}
                    requestRehireDoc={this.state.request_rehire_doc}
                    docRequest={this.state.doc_request}
                    requestRehireDocStatus={this.state.request_rehire_doc_status}
                    onDocumentRequest={this.documentRequest}
                    onDownloadAllDocuments={this.downloadAllDocuments}
                    onDownloadAllDocumentsAsPDF={this.downloadAllDocumentsAsPDF}
                    onDocRequestModalClose={this.docRequestModalClose}
                  />
                ) : (
                  <>
                    <Link to={`/fire-history/${userItem?.data?.hash}`}>
                      <button
                        style={{ fontSize: '11px', padding: '6px 16px' }}
                        className='button print'
                      >
                        Fire History
                      </button>
                    </Link>
                    <Link to={`/fire-history/${userItem?.data?.hash}/legacy`}>
                      <button
                        style={{ fontSize: '11px', padding: '6px 16px' }}
                        className='button print'
                      >
                        Legacy Fire History
                      </button>
                    </Link>
                    {permList.includes('Manage Passwords') && (
                      <ChangePassword
                        userType='user'
                        user={userItem?.data}
                        isAdmin={
                          this.props?.user?.profile?.data?.is_admin !== 0
                            ? true
                            : false
                        }
                      />
                    )}

                    <button
                      style={{ fontSize: '11px', padding: '6px 16px' }}
                      className='button print'
                      onClick={() => window.print()}
                    >
                      Print
                    </button>

                    {permList.includes('Message Employees') && (
                      <button
                        style={{ fontSize: '11px', padding: '6px 16px' }}
                        className='button edit_profile'
                        onClick={this.mailSendOpenModal.bind(this)}
                      >
                        Message
                      </button>
                    )}

                    {editPerm && (
                      <button
                        style={{ fontSize: '11px', padding: '6px 16px' }}
                        className='button edit_profile'
                        onClick={this.statusOpenModal.bind(this)}
                      >
                        Edit Status
                      </button>
                    )}

                    {permList.includes('Remove Employee') && (
                      <button
                        style={{ fontSize: '11px', padding: '6px 16px' }}
                        className='button edit_profile'
                        onClick={this.handleRemoveEmployee.bind(this)}
                      >
                        Remove Employee
                      </button>
                    )}

                    {(permList.includes('Modify SMS Notification Preference') ||
                      userItem?.data.id == userData?.id) &&
                      userItem?.data && (
                        <SmsNotification
                          initialStatus={userItem?.data.sms_notify}
                          providerOptedOutStatus={
                            userItem?.data.sms_provider_opt_out
                          }
                          type={profileType.EMPLOYEE}
                          id={userItem?.data.id}
                          customClass={'edit_profile xs-font'}
                        />
                      )}

                    {permList.includes('Send DD Form') && (
                      <button
                        className='button edit_profile'
                        onClick={this.openDdformConfirmModal.bind(this)}
                        disabled={this.state.sendingDDForm}
                        style={{ fontSize: '11px', padding: '6px 16px' }}
                      >
                        Send DD Form
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-12'>
                <div className='inner_head'>
                  <h2
                    className={this.state.step === 'profile' ? 'active' : ''}
                    onClick={this.changeTab.bind(this, 'profile')}
                  >
                    Profile
                  </h2>
                  {/* userData.docs_status >= 2 &&  */}
                  {permList.includes('Manage Docs') && (
                    <h2
                      className={
                        this.state.step === 'docs-list' ? 'active' : ''
                      }
                      onClick={this.changeTab.bind(this, 'docs-list')}
                    >
                      Documents
                    </h2>
                  )}
                  <h2
                    className={
                      this.state.step === 'qualifications' ? 'active' : ''
                    }
                    onClick={this.changeTab.bind(this, 'qualifications')}
                  >
                    Qualifications
                  </h2>
                  <h2
                    className={this.state.step === 'trainings' ? 'active' : ''}
                    onClick={this.changeTab.bind(this, 'trainings')}
                  >
                    Trainings
                  </h2>

                  {(admin ||
                    this.state.permission.includes('View/Add Management')) && (
                    <h2
                      className={
                        this.state.step === 'management' ? 'active' : ''
                      }
                      onClick={this.changeTab.bind(this, 'management')}
                    >
                      Management
                    </h2>
                  )}

                  {this.props.match.params.hash ==
                    this.props.user?.profile?.data.hash && (
                    <>
                      {admin &&
                        this.props.match.path !== '/profile/:hash' &&
                        this.props.match.path !==
                          '/profile/:hash/docs-list/:category/:doc/:id' && (
                          <h2
                            className={
                              this.state.step === 'permissions' ? 'active' : ''
                            }
                            onClick={this.changeTab.bind(this, 'permissions')}
                          >
                            Permissions
                          </h2>
                        )}
                      {this.state.permission.includes('Bulletin Board') &&
                        this.props.match.path !== '/profile/:hash' &&
                        this.props.match.path !==
                          '/profile/:hash/docs-list/:category/:doc/:id' && (
                          <h2
                            className={
                              this.state.step === 'bulletin' ? 'active' : ''
                            }
                            onClick={this.changeTab.bind(this, 'bulletin')}
                          >
                            Bulletin Board
                          </h2>
                        )}
                    </>
                  )}

                  {(userItem?.data?.applicant_hash ||
                    this.props.user?.items?.data?.applicant_hash) && (
                    <h2
                      className={
                        this.state.step === 'application' ? 'active' : ''
                      }
                      onClick={this.changeTab.bind(this, 'application')}
                    >
                      Application
                    </h2>
                  )}
                </div>
                <div className='tab-contents'>{this.state.mainHtml}</div>
              </div>
            </div>
            <Modal
              id='remove_popup'
              className='status_popup'
              open={this.state.send_dd_form_confirm}
              onClose={this.ddFormConfirmCloseModal.bind(this)}
              little
            >
              <div id='removePopup'>
                <div className='modal-head'>
                  <h4 className='modal-title'>Direct Deposit Form</h4>
                </div>
                <div className='modal-body'>
                  <label>
                    This will send an email to{' '}
                    {this.state.h1 ? this.state.h1 : 'this employee'}, with
                    Direct Deposit form link.
                  </label>
                  <br />
                  <button
                    className='button grey'
                    onClick={this.ddFormConfirmCloseModal.bind(this)}
                  >
                    Cancel
                  </button>
                  <button
                    className='button'
                    onClick={this.sendDDForm.bind(this)}
                  >
                    Send
                  </button>
                </div>
              </div>
            </Modal>
            <Modal
              id='status_popup'
              className='status_popup'
              open={this.state.statusOpen}
              onClose={this.statusCloseModal.bind(this)}
              little
            >
              <div id='statusPopup'>
                <div className='modal-head'>
                  <h4 className='modal-title'>Current Status</h4>
                </div>
                {this.state.statusStep === '1' && (
                  <div className='modal-body'>
                    <div className='status_step step1'>
                      <label>
                        {userItem?.data.first_name +
                          ' ' +
                          userItem?.data.last_name +
                          ' is: '}
                        <span className='green'>{status}</span>
                      </label>
                      <br />
                      <div className='user-status-edit-wrapper'>
                        <div>
                          {this.state.is_locked === 0 && (
                            <button
                              className='button'
                              onClick={this.handleLockProfile.bind(this)}
                            >
                              Lock Profile
                            </button>
                          )}
                          {this.state.is_locked === 1 && (
                            <button
                              className='button'
                              onClick={this.setStep.bind(this, '1a')}
                            >
                              Unlock Profile
                            </button>
                          )}
                        </div>
                        <div>
                          <button
                            className={`button outlined ${
                              this.state.is_locked === 1 ? 'disabled' : ''
                            }`}
                            onClick={this.setStep.bind(this, '2')}
                            disabled={this.state.is_locked === 1}
                          >
                            {status === 'Available'
                              ? 'Make Unavailable'
                              : 'Make Available'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {this.state.statusStep === '1a' && (
                  <div className='modal-body'>
                    <div className='status_step step1'>
                      <section className='d-flex flex-column checkb'>
                        <h6 className='text-bold'>
                          Are you sure you want to Unlock the selected employee
                        </h6>

                        {(userItem?.data.docs_status === -1 ||
                          userItem?.data.rehire_docs_status === -1) && (
                          <label>
                            <input
                              type='checkbox'
                              onChange={this.requireDocs}
                              defaultChecked={this.state.requireDocs}
                            />
                            <span>Ask to fill Documents</span>
                          </label>
                        )}
                      </section>
                      <div className='user-status-edit-wrapper'>
                        <div>
                          <button
                            disabled={this.state.loader}
                            className='button disabled'
                            onClick={this.setStep.bind(this, '2')}
                          >
                            Cancel
                          </button>
                        </div>
                        <div>
                          <button
                            disabled={this.state.loader}
                            className='button'
                            onClick={this.unlockProfile}
                          >
                            Unlock
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {this.state.statusStep === '1b' && (
                  <div className='modal-body'>
                    <div className='status_step step1'>
                      <section className='d-flex flex-column checkb'>
                        <p>
                          Are you sure you want to Lock the selected employee ?
                        </p>
                      </section>
                      <div className='user-status-edit-wrapper'>
                        <div>
                          <button
                            className='button grey'
                            onClick={this.setStep.bind(this, '2')}
                          >
                            Cancel
                          </button>
                        </div>
                        <div>
                          <button
                            className='button'
                            onClick={this.setStep.bind(this, '1c')}
                          >
                            Continue
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {this.state.statusStep === '1c' && (
                  <div className='modal-body'>
                    <div className='status_step step1'>
                      <section className='d-flex flex-column checkb'>
                        <div classNames='full-width'>
                          <p>Last Day Worked</p>
                          <DatePicker
                            className='lastDayWorked'
                            name='lastDayWorked'
                            selected={this.state.lastDayWorked}
                            onChange={this.handleLastDayChange.bind(this)}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode='select'
                          />
                          <textarea
                            rows='3'
                            maxLength={1200}
                            className='lastDayReason'
                            value={this.state.lastDayReason}
                            name='lastDayReason'
                            onChange={this.changeLastDayReason}
                            errors={this.state.lastDayReasonErr}
                          />
                        </div>
                      </section>
                      <div className='user-status-edit-wrapper'>
                        <div>
                          <button
                            disabled={this.state.loader}
                            className='button grey'
                            onClick={this.setStep.bind(this, '2')}
                          >
                            Cancel
                          </button>
                        </div>
                        <div>
                          <button
                            disabled={this.state.loader}
                            className='button'
                            onClick={this.lockProfile}
                          >
                            Lock
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {this.state.statusStep === '2' && available && (
                  <div className='modal-body'>
                    <div className='status_step step2'>
                      <label>Reason for Unavailability: </label>
                      <select
                        name='unavailableReason'
                        className='unavailability_reason'
                        value={this.state.unavailableReason}
                        onChange={this.changeUnavailabilityReason}
                        errors={this.state.unavailableErr}
                      >
                        <option value='0'>-- Select Reason --</option>
                        <option value='1'>Time Off</option>
                        <option value='2'>Sick</option>
                        <option value='3'>Injury</option>
                        <option value='4'>Other</option>
                      </select>
                      {(this.state.unavailableReason === '1' ||
                        this.state.unavailableReason === '2' ||
                        this.state.unavailableReason === '3' ||
                        this.state.unavailableReason === '4') && (
                        <div classNames='full-width'>
                          <textarea
                            rows='3'
                            maxLength={1200}
                            className='other_reason'
                            value={this.state.otherReason}
                            name='otherReason'
                            onChange={this.changeUnavailabilityReason}
                            errors={this.state.unavailableDescriptionErr}
                          />
                        </div>
                      )}
                      <label>Do you know when {namePrefix} will return?</label>
                      <button
                        className='button'
                        onClick={this.setStatusReturn.bind(this, true)}
                      >
                        Yes
                      </button>
                      <button
                        className='button grey'
                        onClick={this.setStatusReturn.bind(this, false)}
                      >
                        No
                      </button>
                      <p className='step_no'>2/3</p>
                    </div>
                  </div>
                )}
                {this.state.statusStep === '2' && !available && (
                  <div className='modal-body'>
                    <div className='status_step step2'>
                      <label>Make Available?</label>
                      <button
                        className='button'
                        onClick={this.changeStatus.bind(this, true, status)}
                        disabled={this.state.loader}
                      >
                        Yes
                      </button>
                      <button
                        className='button grey'
                        onClick={this.statusCloseModal.bind(this)}
                        disabled={this.state.loader}
                      >
                        No
                      </button>
                      <p className='step_no'>2/2</p>
                    </div>
                  </div>
                )}
                {this.state.statusStep === '2a' && (
                  <div className='modal-body'>
                    <div className='status_step step4'>
                      <label>Choose date of return:</label>
                      <DatePicker
                        className='returnDateField'
                        name='returnDateField'
                        selected={this.state.returnDateField}
                        onChange={this.handleDateChange.bind(this)}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode='select'
                        minDate={moment()}
                      />
                      <button
                        className='button btn_margin'
                        onClick={this.setStep.bind(this, '3')}
                      >
                        Next
                      </button>
                      <p className='step_no'>2/3</p>
                    </div>
                  </div>
                )}
                {this.state.statusStep === '2b' && (
                  <div className='modal-body'>
                    <div className='status_step step2'>
                      <label>Make Unavailable?</label>
                      <button
                        className='button'
                        onClick={this.changeStatus.bind(this, true, status)}
                        disabled={this.state.loader}
                      >
                        Yes
                      </button>
                      <button
                        className='button grey'
                        onClick={this.statusCloseModal.bind(this)}
                        disabled={this.state.loader}
                      >
                        No
                      </button>
                      <p className='step_no'>3/3</p>
                    </div>
                  </div>
                )}
                {this.state.statusStep === '3' && (
                  <div className='modal-body'>
                    <div className='status_step step5'>
                      <label>
                        Are you sure you want to switch {namePrefix} to
                        Unavailable?
                      </label>
                      <p>
                        (returning{' '}
                        {this.state.returnDate === ''
                          ? moment().format('MM/DD/YYYY')
                          : formatDate(this.state.returnDate)}
                        )
                      </p>
                      <button
                        className='button'
                        onClick={this.changeStatus.bind(this, true, status)}
                        disabled={this.state.loader}
                      >
                        Yes
                      </button>
                      <button
                        className='button grey'
                        onClick={this.statusCloseModal.bind(this)}
                        disabled={this.state.loader}
                      >
                        No
                      </button>
                      <p>Time off must be approved by your supervisor.</p>
                      <p className='step_no'>3/3</p>
                    </div>
                  </div>
                )}
              </div>
            </Modal>

            <Modal
              id='mail_send_popup'
              className='status_popup'
              open={this.state.mailSendOpen}
              onClose={this.mailSendCloseModal.bind(this)}
              little
            >
              <div id='mailSendPopup'>
                <div className='modal-head'>
                  <h4 className='modal-title'>Custom Message</h4>
                </div>
                <div className='modal-body'>
                  <textarea
                    name='message'
                    cols='80'
                    rows='10'
                    value={this.state.message}
                    onChange={this.handleChange.bind(this)}
                  />

                  <p className='step_no'>
                    Signature will automatically be included.
                  </p>

                  <button
                    className='button grey'
                    style={{ marginRight: '10px' }}
                    onClick={this.mailSendCloseModal.bind(this)}
                  >
                    Cancel
                  </button>
                  <button
                    className='button'
                    onClick={this.sendMail.bind(this, userItem?.data?.hash)}
                  >
                    Send
                  </button>
                </div>
              </div>
            </Modal>

            {this.state.alertPop && (
              <AlertPopup
                head={this.state.alertHead}
                message={this.state.alertMsg}
                alertFunction={this.state.alertFunction}
                close={this.closeAlert.bind(this)}
              />
            )}

            <Modal
              id='remove_popup'
              className='status_popup'
              open={this.state.removeOpen}
              onClose={this.removeCloseModal.bind(this)}
              little
            >
              <div id='removePopup'>
                <div className='modal-head'>
                  <h4 className='modal-title'>
                    Remove Employee:{' '}
                    {userItem?.data?.first_name +
                      ' ' +
                      userItem?.data?.last_name}
                  </h4>
                </div>
                <div className='modal-body'>
                  {this.state.archiveStep == '3a' && (
                    <div>
                      <label>Are you sure you want to archive this employee?</label>
                      <br />
                      <button
                        className='button grey'
                        onClick={this.removeCloseModal.bind(this)}
                      >
                        Cancel
                      </button>
                      <button
                        className='button'
                        onClick={this.collectLastDayWorked.bind(this)}
                      >
                        Archive
                      </button>
                    </div>
                  )}
                  {this.state.archiveStep == '3b' && (
                    <div className='status_step step1'>
                      <section
                        className='d-flex flex-column checkb'
                        style={{ padding: '10px' }}
                      >
                        <div classNames='full-width'>
                          <p>Last Day Worked</p>
                          <DatePicker
                            className='lastDayWorked'
                            name='lastDayWorked'
                            selected={this.state.lastDayWorked}
                            onChange={this.handleLastDayChange.bind(this)}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode='select'
                          />
                          <textarea
                            rows='3'
                            maxLength={1200}
                            className='lastDayReason'
                            value={this.state.lastDayReason}
                            name='lastDayReason'
                            onChange={this.changeLastDayReason}
                            errors={this.state.lastDayReasonErr}
                          />
                        </div>
                      </section>
                      <div className='user-status-edit-wrapper'>
                        <div>
                          <button
                            disabled={this.state.loader}
                            className='button grey'
                            onClick={this.removeCloseModal.bind(this)}
                          >
                            Cancel
                          </button>
                        </div>
                        <div>
                          <button
                            disabled={this.state.loader}
                            className='button'
                            onClick={this.remove}
                          >
                            Archive
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Modal>

            <InventoryAlertModal
              isOpen={this.state.inventoryUserAlert}
              onClose={() => this.setState({ inventoryUserAlert: false })}
              action={this.state.inventoryAlertAction || 'remove'}
              userHash={this.props.match.params.hash}
            />

            {/* Success/Error Alert Modal */}
            <ReactModal
              isOpen={this.state.alertOpen}
              onClose={this.alertCloseModal.bind(this)}
              contentLabel='Minimal Modal Example'
              overlayClassName='alertPopup'
            >
              <div id='statusPopup' className='popupModal'>
                <div className='modal-head'>
                  <h4 className='modal-title'>{this.state.head}</h4>
                </div>
                <div className='modal-body'>
                  <p>{this.state.alertMsg}</p>
                  <div className='btn_list'>
                    <button
                      className='button'
                      onClick={this.alertCloseModal.bind(this)}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </ReactModal>
          </div>
        </div>
      </div>
    );
  }
}

SettingsProfile.propTypes = {
  match: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  permission: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const { applicants, user, permission, chat, inventory } = state;
  return {
    applicants,
    user,
    permission,
    chat,
    inventory,
  };
}
const connectedHomePage = connect(mapStateToProps)(SettingsProfile);
export { connectedHomePage as SettingsProfile };
